import { Link, useLocation, useNavigate } from 'react-router-dom'
import { images, signUpImages } from '../../services/images.service'
import { loginWithGoogle } from '../../store/slices/user.slice'
import { useDispatch } from 'react-redux'
import { closeNotRegisteredPopup } from '../../store/slices/ui.slice'
import { Button } from '../../cmps/ui/elements'
import anizonelogo from '../../assets/imgs/anizone-logo.svg'

export function NotRegistered() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()

  async function onGoogleLogin() {
    try {
      await dispatch(loginWithGoogle()).unwrap()
      dispatch(closeNotRegisteredPopup())
    } catch (err) {
      // השגיאה כבר טופלה בקונטרולר
    }
  }
  return (
    <div className="flex min-h-screen flex-col justify-center items-center gap-4 md:gap-24">
      <img className="w-[300px]" src={anizonelogo} alt="AniZone Logo" />

      <div className="flex flex-col gap-4 items-center">
        <span className="text-2xl">אוהיו נאקמה! 👋</span>
        <h1 className="text-5xl text-white text-center">
          הירשם או התחבר כדי לגשת לכל הפעולות באתר
        </h1>
      </div>

      <div className="flex flex-col md:flex-row gap-4">
        <Button
          text="הרשמה"
          to="/signup"
          fontSize="text-xl"
          width={214}
          height={75}
          textColor="text-white"
          bgColor="fill-[#BD0029]"
          onClick={() => dispatch(closeNotRegisteredPopup())}
          aria-label="מעבר לעמוד הרשמה"
          title="הירשם לאניזון"
          type="link"
        />

        <Button
          text="התחברות"
          to="/login"
          fontSize="text-xl"
          width={208}
          height={67}
          textColor="text-white"
          bgColor="fill-[#5B0014]"
          onClick={() => dispatch(closeNotRegisteredPopup())}
          aria-label="מעבר לעמוד התחברות"
          title="התחברות לחשבון אניזון"
          type="link"
        />
      </div>

      {/* מחלק */}
      <div className="w-[320px] md:w-[520px]">
        <img className="mb-4 w-full" src={signUpImages.divider} alt="Divider" />

        {/* התחברות דרך צד שלישי */}
        <div className="flex justify-center w-full">
          <button
            onClick={onGoogleLogin}
            className="flex items-center justify-center w-full gap-3 px-4 py-2 bg-[#3A3A3A] hover:scale-105 transition-transform"
          >
            <img
              src={signUpImages.googleIcon}
              alt="Google sign up"
              className="w-6 h-6"
            />
            <span className="text-primaryText">התחברות עם גוגל</span>
          </button>
        </div>
      </div>
    </div>
  )
}
